module.exports = function(expertiseKind) {
    return {
        run() {
            // Модальное окно получения информационного письма
            $('body').on('click', '.inf-letter', function(event) {
                event.preventDefault();
                $('#modal-inf-letter').css('display','block');
            });
            $('body').on('click', '#inf-letter-submit', function(event) {
                event.preventDefault();
                axios.post('/form_data', {
                    name: $('#inf-letter-name').val(),
                    email: $('#inf-letter-email').val(),
                    validate: 'inf-letter',
                    kind: expertiseKind,
                    type: 'toAmo',
                    city: $('#current-city-value').text(),
                    site: domain,
                    form_name: 'Модальное окно получения информационного письма'
                })
                .then(function () {
                    $('.inf-letter-danger').addClass('d-none');
                    $('#inf-letter-success').show(400);
                    $('#inf-letter-name').val('');
                    $('#inf-letter-email').val('');
                    setTimeout(function() {
                        $('#inf-letter-success').hide(300);
                        $('#modal-inf-letter').fadeOut(300);
                    }, 4000);
                })
                .catch(function() {
                    $('.inf-letter-danger').removeClass('d-none');
                    $('#inf-letter-success').hide(300);
                });
            });

            // Модальное окно получения бесплатной консультации
            $('body').on('click', '.expert-consultation-trigger-modal', function(event) {
                event.preventDefault();
                $('#modal-expert-consultation').css('display','block');
            });
            $('body').on('click', '#expert-consultation-submit', function(event) {
                event.preventDefault();
                axios.post('/form_data', {
                    name: $('#expert-consultation-name').val(),
                    phone: $('#expert-consultation-phone').val(),
                    validate: 'expert-consultation',
                    kind: expertiseKind,
                    type: 'toAmo',
                    city: $('#current-city-value').text(),
                    site: domain,
                    form_name: 'Модальное окно получения бесплатной консультации'
                })
                .then(function () {
                    $('.expert-consultation-danger').addClass('d-none');
                    $('#expert-consultation-success').show(400);
                    $('#expert-consultation-name').val('');
                    $('#expert-consultation-phone').val('');
                    setTimeout(function() {
                        $('#expert-consultation-success').hide(300);
                        $('#modal-expert-consultation').fadeOut(300);
                    }, 4000);
                })
                .catch(function() {
                    $('.expert-consultation-danger').removeClass('d-none');
                    $('#expert-consultation-success').hide(300);
                });
            });

            // Модальное окно проведения экспертизы
            $('body').on('click', '.make-examination', function(event) {
                event.preventDefault();
                $('#modal-make-examination').css('display','block');
            });
            $('body').on('click', '#make-examination-submit', function(event) {
                event.preventDefault();
                axios.post('/form_data', {
                    name: $('#make-examination-name').val(),
                    phone: $('#make-examination-phone').val(),
                    validate: 'make-examination',
                    kind: expertiseKind,
                    type: 'toAmo',
                    city: $('#current-city-value').text(),
                    site: domain,
                    form_name: 'Модальное окно проведения экспертизы'
                })
                .then(function () {
                    $('.make-examination-danger').addClass('d-none');
                    $('#make-examination-success').show(400);
                    $('#make-examination-name').val('');
                    $('#make-examination-phone').val('');
                    setTimeout(function() {
                        $('#make-examination-success').hide(300);
                        $('#modal-make-examination').fadeOut(300);
                    }, 4000);
                })
                .catch(function() {
                    $('.make-examination-danger').removeClass('d-none');
                    $('#make-examination-success').hide(300);
                });
            });

            // Модальное окно вопросов
            $('body').on('click', '.ask-question', function(event) {
                event.preventDefault();
                $('#modal-ask-question').css('display','block');
            });
            $('body').on('click', '#ask-question-submit', function(event) {
                event.preventDefault();
                $(this).closest('.inputs').find('.spinner-wrapper').removeClass('d-none').addClass('d-flex');
                
                axios.post('/form_data', {
                    question: $('#ask-question-text').val(),
                    email: $('#ask-question-email').val(),
                    phone: $('#ask-question-phone').val(),
                    validate: 'ask-question',
                    kind: expertiseKind,
                    type: 'toAmo',
                    city: $('#current-city-value').text(),
                    site: domain,
                    form_name: 'Модальное окно вопросов'
                })
                .then(() => {
                    $(this).closest('.inputs').find('.spinner-wrapper').removeClass('d-flex').addClass('d-none');
                    $('.ask-question-danger').addClass('d-none');
                    $('#ask-question-success').show(400);
                    $('#ask-question-text').val('');
                    $('#ask-question-email').val('');
                    $('#ask-question-phone').val('');
                    setTimeout(function() {
                        $('#ask-question-success').hide(300);
                        $('#modal-ask-question').fadeOut(300);
                    }, 4000);
                })
                .catch(() => {
                    $(this).closest('.inputs').find('.spinner-wrapper').removeClass('d-flex').addClass('d-none');
                    $('.ask-question-danger').removeClass('d-none');
                    $('#ask-question-success').hide(300);
                });
            });
        }
    }
}
